import Point from '../point'
import isDom from 'is-dom'

import DOMFactory from './dom'

/**
 * @namespace
 */
const Views = {
    DOM: DOMFactory({ Point, isDom })
}

export default Views



//////////////////
// WEBPACK FOOTER
// ./~/honeycomb-grid/src/views/index.js
// module id = 18
// module chunks = 0